<template>
  <router-link
    class="flex items-center uppercase tracking-widest text-sm font-light py-1 hover:text-highlight transition-colors"
    activeClass="text-highlight"
    :to="to"
  >
    <Font-awesome-icon
      class="w-5 mr-4 flex-none"
      :icon="[iconType, icon]"
      size="lg"
    />
    <span class="truncate">
      <slot>{{ text }}</slot>
    </span>
    <span v-if="count !== null" class="ml-2 text-highlight normal-case">
      &middot; {{ count }}
    </span>
  </router-link>
</template>

<script>
export default {
  name: "NavigationBarLink",
  props: {
    text: { default: "" },
    to: { required: true },
    icon: { default: "" },
    iconType: { default: "far" },
    count: { default: null },
  },
};
</script>
